import type { FaqItem } from "@/components/feature/FaqAccordion";

/**
 * Partner-program FAQs for the /farm-partner page. These power both the
 * on-page FAQ accordion and the matching FAQPage structured data.
 */
export const partnerFaqs: FaqItem[] = [
  {
    q: "Do I need to pay anything to become a farm partner?",
    a: "No. Applying is completely free and there are no listing or subscription charges. We only earn when you host a visitor, and every arrangement is explained to you upfront — there are no hidden deductions and no obligation to say yes.",
  },
  {
    q: "What kind of farms can join Rythugaru?",
    a: "Any working farm that genuinely welcomes visitors can apply — paddy and grain farms, coconut and fruit orchards, banana and plantation farms, dairy and livestock farms, and mixed smallholdings. What matters most is that you enjoy sharing your land, your work and your story with guests.",
  },
  {
    q: "How much time does it take to get listed?",
    a: "After you submit an application we usually call within 2 to 3 working days, then arrange a friendly visit at your convenience. Once we've met, set up your profile and planned your experiences, most farms go live within two to three weeks.",
  },
  {
    q: "Do I have to host visitors on days I'm busy?",
    a: "Never. You stay fully in control of your calendar — you tell us which dates and times work for you, and we only confirm bookings within those windows. If you're in the middle of harvest or a festival, you can simply pause hosting.",
  },
  {
    q: "How and when do I receive payments?",
    a: "Payments are transparent and prompt. We agree the terms with you before your first visit, keep a clear record of every booking you host, and settle your share directly to your bank account or UPI. If anything looks unclear, our team walks you through it.",
  },
  {
    q: "I don't speak much English — can I still partner?",
    a: "Yes, and it's not a problem at all. Our team communicates in Telugu as well as English, and we help with everything from writing your farm story to planning activities. You bring the farming knowledge — we handle the technical and language side.",
  },
];